import React, { useState, useContext, useEffect } from "react";
import Loader from "../../../components/Loader";
import { UserServiceContext } from "../../../services/user/userService";
import SearchableSelect from "../../../components/SearchableSelect";
import CustomAlert from "../../../components/CustomAlert";

const NewAddressModal = ({ setCreateEventModal, isEdit, id, originalData }) => {


  const { getUserTypes, userTypes, loading, addUserFavoriteClient, updateUserFavoriteClient } =
    useContext(UserServiceContext);
  const [errors, setErrors] = useState({});
  const [updatedUserTypes, setUpdatedUserTypes] = useState([]);

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });

  const [formData, setFormData] = useState({
    id: undefined,
    name: "",
    personalId: "",
    userTypeId: "",
  });

  const fetchUserTypes = async () => {
    await getUserTypes();
  };

  useEffect(() => {
    if (originalData) {
      setFormData({
        id: originalData.id,
        name: originalData.name || "",
        personalId: originalData.personalId || "",
        userTypeId: originalData.userTypeId || "",
      });
    }
  }, [originalData]);

  // useEffect(() => {
  //   fetchUserTypes();
  // }, []);



  // useEffect(() => {
  //   if (userTypes.length != 0) {
  //     const updatedData = userTypes.map(({ value, ...rest }) => ({
  //       name: value,
  //       ...rest,
  //     }));
  //     setUpdatedUserTypes(updatedData);
  //     //console.log(updatedData);
  //   }
  // }, [userTypes]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(name, value);
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.name) {
      errors.name = "დასახელება სავალდებულოა";
    }

    if (!formData.personalId) {
      errors.personalId = "პირადი ნომერი სავალდებულოა";
    }

    if (!formData.userTypeId) {
      errors.userTypeId = "მომხმარებლის ტიპი სავალდებულოა";
    }

    setErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    let response = {};


    if (isEdit) {
      response = await updateUserFavoriteClient(formData);
    }
    else {
      response = await addUserFavoriteClient(formData);
    }

    //console.log(response);
    if (response.data && response.data.success) {
      setCreateEventModal(true);//close modal and notify changes
    } else {
      setAlertConfig({
        show: true,
        title: "შეცდომა",
        text: response.message,
        icon: "error",
        onCancel: () => setAlertConfig({ ...alertConfig, show: false }),
      });
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <CustomAlert {...alertConfig} />
      <div
        className={`fixed p-15 w-full max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]`}
      >
        <div className="py-10 md:px-10 px-[7px] bg-card-color rounded-lg shadow-shadow-lg">
          <div className="my-10 lg:px-20 md:px-10 px-[7px] md:max-h-[80svh] max-h-[60svh] overflow-auto custom-scrollbar">
            <div className="text-[24px]/[30px] font-medium mb-2">
              მისამართის {isEdit ? "რედაქტირება" : "დამატება"}
            </div>
            <div className="text-[14px]/[20px] font-medium mb-2">
              <form onSubmit={handleSubmit}>
                <div className="form-control mb-15">
                  <label htmlFor="userTypeId" className="form-label">
                    მომხმარებლის ტიპი
                  </label>
                  <div className="flex gap-30">
                    <div className="form-control mb-5 flex flex-row items-center gap-2">
                      <input
                        type="radio"
                        name="userTypeId"
                        value="1"
                        checked={formData.userTypeId == 1}
                        onChange={(e) => handleChange(e)}
                        className="form-radio"
                        id="userTypeId1"
                      />
                      <label className="form-label mb-0" for="userTypeId1">ფიზიკური პირი</label>
                    </div>
                    <div className="form-control mb-5 flex flex-row items-center gap-2">
                      <input
                        type="radio"
                        name="userTypeId"
                        value="2"
                        checked={formData.userTypeId == 2}
                        onChange={(e) => handleChange(e)}
                        className="form-radio"
                        id="userTypeId2"
                      />
                      <label className="form-label mb-0" for="userTypeId2">იურიდიული პირი</label>
                    </div>
                  </div>
                  {errors.userTypeId && (
                    <div className="text-danger text-[14px]/[20px]">
                      {errors.userTypeId}
                    </div>
                  )}
                </div>
                <div className="form-control mb-15">
                  <label htmlFor="name" className="form-label">
                    დასახელება
                  </label>
                  <input
                    id="name"
                    placeholder="დასახელება"
                    required
                    className="form-input"
                    name="name"
                    value={formData.name}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.name && (
                    <div className="text-danger text-[14px]/[20px]">
                      {errors.name}
                    </div>
                  )}
                </div>
                <div className="form-control mb-15">
                  <label htmlFor="personalId" className="form-label">
                    {formData.userTypeId === "1"
                      ? "პირადი ნომერი"
                      : "საიდენტიფიკაციო კოდი"}
                  </label>
                  <input
                    id="personalId"
                    placeholder={formData.userTypeId === "1"
                      ? "პირადი ნომერი"
                      : "საიდენტიფიკაციო კოდი"}
                    required
                    className="form-input"
                    name="personalId"
                    value={formData.personalId}
                    onChange={(e) => handleChange(e)}
                  />
                  {errors.personalId && (
                    <div className="text-danger text-[14px]/[20px]">
                      {errors.personalId}
                    </div>
                  )}
                </div>
                <div
                  className="flex items-stretch gap-5"
                  style={{ marginTop: "120px" }}
                >
                  <button type={"submit"} className="btn btn-primary">
                    {isEdit ? "რედაქტირება" : "დამატება"}
                  </button>
                  <button
                    onClick={() => setCreateEventModal(false)}
                    className="btn btn-secondary"
                  >
                    გაუქმება
                  </button>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={setCreateEventModal}
        className={`contents-[] fixed z-[5] w-full h-full left-0 top-0 bg-black-50 backdrop-blur-[2px]`}
      ></div>
    </>
  );
};

export default NewAddressModal;
